<template>
  <section class="specifications-section-container">
    <div class="content-wrapper">
      <div class="title-wrapper">
        <div class="title">
          <h2>technikai</h2>
          <div class="underline"></div>
        </div>
        <div class="title">
          <h2>adatok</h2>
          <div class="underline"></div>
        </div>
      </div>
      <div class="spec-block">
        <div class="left-text">
          <p>
            magasság <br>
            szélesség <br>
            vastagság <br>
            súly <br>
            élhossz <br>
            keménység <br>
            bevonat <br>
            felépítés <br>
            markolat
          </p>
        </div>
        <div id="vertical-separator">
            <br><br><br><br><br><br><br><br><br><br>
        </div>
        <div class="right-text">
          <p>
            420 mm <br>
            118 mm <br>
            4 mm <br>
            392 g <br>
            40 mm <br>
            52 - 53 HCR <br>
            fekete oxid <br>
            full tang <br>
            paracord
          </p>
        </div>
      </div>
      <div class="left-decor">
        <img src="../assets/background_elements/schematic.png" alt="schematic">
      </div>
      <div class="right-decor">
        <img src="../assets/background_elements/grid.png" alt="schematic">
      </div>
    </div>
    <div id="scrollto-preorder"></div>
  </section>
</template>

<script>
export default {
  name: "SpecificationsSection"
}
</script>

<style scoped>
.specifications-section-container {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #FFFFFF;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1850px;
}

.title-wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  top: 5%;
  right: 4%;
}

.title {
  text-align: right;
  line-height: 1.1;
}

h2 {
  font-size: 64px;
  font-weight: 900;
  text-transform: uppercase;
}

.underline {
  background: #EFBE3E;
  height: 6px;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 0.5rem;
}

.spec-block {
  display: flex;
  align-items: center;
  height: 100%;
  line-height: 2;
  font-size: 20px;
  padding: 175px 0;
}

.left-text {
  text-align: right;
}

#vertical-separator {
  height: 100%;
  border-radius: 10px;
  width: 3px;
  background: #EFBE3E;
  margin: 0 25px;
}

.right-text {
  font-weight: bold;
}

.left-decor img {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 60%;
}

.right-decor img {
  position: absolute;
  transform: rotate(180deg) scaleX(-1);
  bottom: 0;
  right: 0;
  height: 40%;
}

@media only screen and (max-width: 1200px) {
  img {
    display: none;
  }

  h2 {
    font-size: 48px;
  }

  .spec-block {
    padding: 100px 0;
  }

  .title-wrapper {
    margin-top: 7%;
    position: static;
    align-items: center;
  }

  .specifications-section-container {
    position: relative;
    background: url(../assets/background_elements/bgpattern.png) no-repeat top;
    background-size: cover;
  }

  .specifications-section-container::after {
    content: "";
    background: white;
    opacity: 1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }
}

@media only screen and (max-width: 900px) {
  .spec-block {
    padding: 75px 0;
  }

  h2 {
    font-size: 48px;
  }
}

@media only screen and (max-width: 700px) {
  .specifications-section-container {
    background: #FFFFFF;
  }

  .specifications-section-container::after {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  h2 {
    font-size: 34px;
  }
}
</style>
